/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteBooking } from '../fn/bookings/delete-booking';
import { DeleteBooking$Params } from '../fn/bookings/delete-booking';
import { GetBookingLieuResult } from '../models/get-booking-lieu-result';
import { GetBookingResult } from '../models/get-booking-result';
import { getBookings } from '../fn/bookings/get-bookings';
import { GetBookings$Params } from '../fn/bookings/get-bookings';
import { GetBookingsResult } from '../models/get-bookings-result';
import { getByBookingid } from '../fn/bookings/get-by-bookingid';
import { GetByBookingid$Params } from '../fn/bookings/get-by-bookingid';
import { getByBookingidGeneratePdf } from '../fn/bookings/get-by-bookingid-generate-pdf';
import { GetByBookingidGeneratePdf$Params } from '../fn/bookings/get-by-bookingid-generate-pdf';
import { getLieux } from '../fn/bookings/get-lieux';
import { GetLieux$Params } from '../fn/bookings/get-lieux';
import { getSlots } from '../fn/bookings/get-slots';
import { GetSlots$Params } from '../fn/bookings/get-slots';
import { GetSlotsResult } from '../models/get-slots-result';
import { postSaveBooking } from '../fn/bookings/post-save-booking';
import { PostSaveBooking$Params } from '../fn/bookings/post-save-booking';
import { SaveBookingResult } from '../models/save-booking-result';

@Injectable({ providedIn: 'root' })
export class ApiBookingsService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `deleteBookingsBooking()` */
  static readonly DeleteBookingsBookingPath = '/Bookings/booking';

  /**
   * delete-bookings-booking.
   *
   * Delete Booking<br>Delete a booking with his id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteBooking()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteBooking$Response(params?: DeleteBooking$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * delete-bookings-booking.
   *
   * Delete Booking<br>Delete a booking with his id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteBooking$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteBooking(params?: DeleteBooking$Params, context?: HttpContext): Observable<void> {
    return this.deleteBooking$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `getBookingsByBookingid()` */
  static readonly GetBookingsByBookingidPath = '/Bookings/{BookingId}';

  /**
   * get-bookings-by-bookingid.
   *
   * Get Bookings<br>Get the list of booking for a site
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByBookingid()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByBookingid$Response(params: GetByBookingid$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBookingResult>> {
    return getByBookingid(this.http, this.rootUrl, params, context);
  }

  /**
   * get-bookings-by-bookingid.
   *
   * Get Bookings<br>Get the list of booking for a site
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByBookingid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByBookingid(params: GetByBookingid$Params, context?: HttpContext): Observable<GetBookingResult> {
    return this.getByBookingid$Response(params, context).pipe(map((r: StrictHttpResponse<GetBookingResult>): GetBookingResult => r.body));
  }

  /** Path part for operation `getBookingsLieux()` */
  static readonly GetBookingsLieuxPath = '/Bookings/lieux';

  /**
   * get-bookings-lieux.
   *
   * Get booking lieu<br>Get the list of lieu for a site
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLieux()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLieux$Response(params?: GetLieux$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBookingLieuResult>> {
    return getLieux(this.http, this.rootUrl, params, context);
  }

  /**
   * get-bookings-lieux.
   *
   * Get booking lieu<br>Get the list of lieu for a site
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLieux$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLieux(params?: GetLieux$Params, context?: HttpContext): Observable<GetBookingLieuResult> {
    return this.getLieux$Response(params, context).pipe(map((r: StrictHttpResponse<GetBookingLieuResult>): GetBookingLieuResult => r.body));
  }

  /** Path part for operation `getBookingsByBookingidGeneratePdf()` */
  static readonly GetBookingsByBookingidGeneratePdfPath = '/Bookings/{BookingId}/generate-pdf';

  /**
   * get-bookings-by-bookingid-generate-pdf.
   *
   * Generate booking pdf
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByBookingidGeneratePdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByBookingidGeneratePdf$Response(params: GetByBookingidGeneratePdf$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return getByBookingidGeneratePdf(this.http, this.rootUrl, params, context);
  }

  /**
   * get-bookings-by-bookingid-generate-pdf.
   *
   * Generate booking pdf
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByBookingidGeneratePdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByBookingidGeneratePdf(params: GetByBookingidGeneratePdf$Params, context?: HttpContext): Observable<any> {
    return this.getByBookingidGeneratePdf$Response(params, context).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }

  /** Path part for operation `getBookings()` */
  static readonly GetBookingsPath = '/Bookings';

  /**
   * get-bookings.
   *
   * Get Bookings<br>Get the list of booking for a site
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookings$Response(params?: GetBookings$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBookingsResult>> {
    return getBookings(this.http, this.rootUrl, params, context);
  }

  /**
   * get-bookings.
   *
   * Get Bookings<br>Get the list of booking for a site
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookings(params?: GetBookings$Params, context?: HttpContext): Observable<GetBookingsResult> {
    return this.getBookings$Response(params, context).pipe(map((r: StrictHttpResponse<GetBookingsResult>): GetBookingsResult => r.body));
  }

  /** Path part for operation `getBookingsSlots()` */
  static readonly GetBookingsSlotsPath = '/Bookings/slots';

  /**
   * get-bookings-slots.
   *
   * Get slots<br>Get the list of slots for a lieu
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSlots()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSlots$Response(params?: GetSlots$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSlotsResult>> {
    return getSlots(this.http, this.rootUrl, params, context);
  }

  /**
   * get-bookings-slots.
   *
   * Get slots<br>Get the list of slots for a lieu
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSlots$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSlots(params?: GetSlots$Params, context?: HttpContext): Observable<GetSlotsResult> {
    return this.getSlots$Response(params, context).pipe(map((r: StrictHttpResponse<GetSlotsResult>): GetSlotsResult => r.body));
  }

  /** Path part for operation `postBookingsSaveBooking()` */
  static readonly PostBookingsSaveBookingPath = '/Bookings/save-booking';

  /**
   * post-bookings-save-booking.
   *
   * Save booking<br>save a booking for a date and lieu
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postSaveBooking()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postSaveBooking$Response(params?: PostSaveBooking$Params, context?: HttpContext): Observable<StrictHttpResponse<SaveBookingResult>> {
    return postSaveBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * post-bookings-save-booking.
   *
   * Save booking<br>save a booking for a date and lieu
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postSaveBooking$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postSaveBooking(params?: PostSaveBooking$Params, context?: HttpContext): Observable<SaveBookingResult> {
    return this.postSaveBooking$Response(params, context).pipe(map((r: StrictHttpResponse<SaveBookingResult>): SaveBookingResult => r.body));
  }
}
